import { WhatsApp } from 'constants/messageMediums';
import { MessageMedium } from 'modules/domains/campaign';
import { useCampaignContext, useTemplateContext } from '../../../context';

import { CampaignFormField, ReadOnlyField } from '../../FormFields';
import { LightText, SectionHeader, SectionWrapper } from '../Sections.styled';
import { EmailSendingInformationSection } from './EmailSendingInformation';
import { InAppSendingInformation } from './InAppSendingInformation';
import { PushSendingInformationSection } from './PushSendingInformation';
import { SMSSendingInformationSection } from './SMSSendingInformation';
import { WhatsAppSendingInformationSection } from './WhatsAppSendingInformation';

export const SENDING_INFORMATION_SECTION_TEST_ID = 'sending-information-section';

export const SendingInformationSection = () => {
  const { templateAndContent, templateLocales } = useTemplateContext();
  const { messageType } = templateAndContent;

  const { campaign } = useCampaignContext();
  const { messageMedium } = campaign;
  return (
    <SectionWrapper data-test={SENDING_INFORMATION_SECTION_TEST_ID}>
      <SectionHeader>Sending information</SectionHeader>
      <CampaignFormField labelText="Message type">
        <ReadOnlyField name="messageType">
          {messageType?.name || <LightText>Not set</LightText>}
        </ReadOnlyField>
      </CampaignFormField>
      <CampaignFormField labelText="Locales">
        <ReadOnlyField name="locales">
          {templateLocales?.map((locale, i) => {
            const comma = i === templateLocales.length - 1 ? '' : ',';
            return `${locale}${comma} `;
          }) || <LightText>Not set</LightText>}
        </ReadOnlyField>
      </CampaignFormField>
      {messageMedium === MessageMedium.InApp && <InAppSendingInformation />}
      {messageMedium === MessageMedium.SMS && <SMSSendingInformationSection />}
      {messageMedium === MessageMedium.Email && <EmailSendingInformationSection />}
      {messageMedium === MessageMedium.Push && <PushSendingInformationSection />}
      {messageMedium === WhatsApp && <WhatsAppSendingInformationSection />}
    </SectionWrapper>
  );
};
